import React from 'react';
import { Button, TagPicker, Modal } from 'rsuite';
const TableCustomizeDetails = ({open,handleClose,defaultColumns,columnKeys,setColumnKeys}) => {
  return (
    <div>
      <Modal open={open} onClose={handleClose} backdrop={'static'}>
        <Modal.Header>
          <Modal.Title>
            <h3 className="title">Customize Details</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TagPicker
            data={defaultColumns}
            labelKey="label"
            valueKey="key"
            value={columnKeys}
            onChange={setColumnKeys}
            cleanable={false}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} appearance="primary" color="cyan">
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TableCustomizeDetails;
